import Swiper from 'swiper';

export function initGlossaryAlphabetSlider(parent) {
  if (!parent) return;

  const swiperEl = parent.querySelector('.glossary-listing__alphabet-swiper');
  if (!swiperEl) return;

  new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 4,
  });
}

export function initAllGlossaryAlphabetSliders() {
  const sliders = document.querySelectorAll('.js-glossary-alphabet-slider');
  sliders.forEach((slider) => initGlossaryAlphabetSlider(slider));
}
